/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
window.App.Components.YoutubeVideoSeekTo = class YoutubeVideoSeekTo {
  constructor(options) {
    this.onSeekTo = this.onSeekTo.bind(this)
    this.seconds = this.seconds.bind(this)
    this.player = options.player
    this.selector = options.selector

    $(document).on("click", this.selector, e => this.onSeekTo(e))
  }

  onSeekTo(e) {
    this.player.seekTo(this.seconds())
    return this.player.playVideo()
  }

  seconds() {
    return $(this.selector).data("seconds")
  }
}
